import React, { memo, useCallback } from 'react';
import PerformanceMark from '@atlassian/jira-common-performance/src/set-performance-mark.tsx';
import {
	PAGE_LAYOUT_MARK,
	PAGE_CONTAINER_END_MARK,
	GLOBAL_CONTAINERS_END_MARK,
} from '@atlassian/jira-page-container-constants/src/index.tsx';
import { setInitialPageLoadTimingFromPerformanceMarks } from '@atlassian/jira-spa-performance-breakdown/src/utils/performance-marks-tools/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useFaviconService } from '@atlassian/jira-favicon/src/index.tsx';
import { ForgeUiGlobalExtensionsAsync } from '@atlassian/jira-forge-ui-global-extensions/src/ui/async.tsx';
import { PageContainer } from '../../common/ui/page-container/main.tsx';
import { Content } from './content/index.tsx';
import type { SpaProps } from './types.tsx';
import { MemoryMonitor } from './memory-monitor.tsx';
import { ReadinessTracker } from './readiness-tracker.tsx';
import { HotfixTesting } from './hotfix-testing.tsx';
import { HydrationAdvisory } from './HydrationAdvisory.tsx';

const FaviconService = memo(() => {
	useFaviconService();

	return null;
});

export const Spa = ({
	locale,
	messages,
	isPrewarming = false,
	Router,
	routes,
	routerLinkComponent,
	initRoute,
}: SpaProps) => {
	const pageContainerPerformanceTiming = useCallback(() => {
		setInitialPageLoadTimingFromPerformanceMarks(
			PAGE_LAYOUT_MARK,
			GLOBAL_CONTAINERS_END_MARK,
			PAGE_CONTAINER_END_MARK,
			true,
			true,
		);
	}, []);

	const content = (
		<PageContainer
			id={__SERVER__ ? 'jira.entry.ssr' : 'spa'}
			locale={locale}
			messages={messages}
			Router={Router}
			routerLinkComponent={routerLinkComponent}
		>
			{fg('jira_frontend_memory_monitor') && <MemoryMonitor />}
			<ReadinessTracker />
			<FaviconService />
			<PerformanceMark metricKey={PAGE_CONTAINER_END_MARK} onSet={pageContainerPerformanceTiming} />
			{isPrewarming !== true && <Content initRoute={initRoute} routes={routes} />}
			{fg('magma-hotfix-testing') && <HotfixTesting />}
			{fg('ditto_fcf_jira_globalbackgroundscript') && <ForgeUiGlobalExtensionsAsync />}
		</PageContainer>
	);

	if (fg('jfp-magma-hydration-advisory')) {
		return (
			<>
				{content}
				{/* Rendered outside page container to avoid adding any DOM nodes to layout */}
				<HydrationAdvisory />
			</>
		);
	}
	return content;
};
